import React, { useState } from 'react'
import './Draw_Details.css'
import Message_Modal from '../../common_components/common_modal/message_modal/Message_Modal'
import { Table } from 'react-bootstrap'

const Draw_Details = () => {

    const [showModal, setShowModal] = useState(true)

    const fun_Roulette = [
        { srNo: 1, drawNo: "NOT OPEN", drawTime: "05-MAY-2025 11:48:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 1, drawNo: "NOT OPEN", drawTime: "05-MAY-2025 11:48:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: 30, drawTime: "05-MAY-2025 11:47:47 AM" },
    ]

    const fun_AndarBahar = [
        { srNo: 1, drawNo: "♠ 3", drawTime: "05-MAY-2025 11:48:47 AM" },
        { srNo: 2, drawNo: "♥ 5", drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: "♦ Q", drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: "♣ 8", drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 1, drawNo: "♠ 3", drawTime: "05-MAY-2025 11:48:47 AM" },
        { srNo: 2, drawNo: "♥ 5", drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: "♦ Q", drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: "♣ 8", drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 1, drawNo: "♠ 3", drawTime: "05-MAY-2025 11:48:47 AM" },
        { srNo: 2, drawNo: "♥ 5", drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: "♦ Q", drawTime: "05-MAY-2025 11:47:47 AM" },
        { srNo: 2, drawNo: "♣ 8", drawTime: "05-MAY-2025 11:47:47 AM" },
    ]

    return (
        <section className='Draw_Details'>

            <div className='refresh_btn_holder'>
                <button className='blue_btn'>Refresh</button>
            </div>

            <div className='all_tables_holder'>
                <div className='row me-0 ms-0'>
                    {/* <div className="col-xl-4 col-sm-6 ">
                        <div className='game_table'>
                            <div className="table_header">Fun Roulette</div>

                            <div className='table-responsive fixed-height-scroll'>
                                <Table className='custom_table'>
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Draw No.</th>
                                            <th>Draw Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fun_Roulette?.map((row, i) => (
                                            <tr key={i}>
                                                <td>{row.srNo}</td>
                                                <td>{row.drawNo}</td>
                                                <td>{row.drawTime}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div> */}

                    <div className="col-xl-4 col-sm-6 ">
                        <div className='game_table'>
                            <div className="table_header">Fun Target</div>

                            <div className='table-responsive fixed-height-scroll'>
                                <Table className='custom_table'>
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Draw No.</th>
                                            <th>Draw Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fun_Roulette?.map((row, i) => (
                                            <tr key={i}>
                                                <td>{row.srNo}</td>
                                                <td>{row.drawNo}</td>
                                                <td>{row.drawTime}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>

                    {/* <div className="col-xl-4 col-sm-6 ">
                        <div className='game_table'>
                            <div className="table_header">Triple Fun</div>

                            <div className='table-responsive fixed-height-scroll'>
                                <Table className='custom_table'>
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Draw No.</th>
                                            <th>Draw Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fun_Roulette?.map((row, i) => (
                                            <tr key={i}>
                                                <td>{row.srNo}</td>
                                                <td>{row.drawNo}</td>
                                                <td>{row.drawTime}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div> */}

                    {/* <div className="col-xl-4 col-sm-6 ">
                        <div className='game_table'>
                            <div className="table_header">Fun Andar Bahar</div>

                            <div className='table-responsive fixed-height-scroll'>
                                <Table className='custom_table'>
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Draw No.</th>
                                            <th>Draw Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fun_AndarBahar?.map((row, i) => {
                                            const isRed = row.drawNo.includes('♥') || row.drawNo.includes('♦');
                                            return (
                                                <tr key={i}>
                                                    <td>{row.srNo}</td>
                                                    <td className={isRed ? 'red-suit' : ''}>{row.drawNo}</td>
                                                    <td>{row.drawTime}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div> */}

                </div>
            </div>


            <Message_Modal
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </section>
    )
}

export default Draw_Details
